import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'courses',
            name: 'course',
            class: 'Modules\\Site\\Entities\\Course'
        }
    }
}